import HintProblemService from './service/HintProblemService';
import MetaService from './service/MetaService';
import axios from 'axios';

axios.defaults.baseURL = import.meta.env.VITE_API_URL;

const globalHintProblemService = new HintProblemService();
const globalMetaService = new MetaService();
axios.interceptors.response.use((response) => {
    globalHintProblemService.handleNewProblemsHeader(response);
    globalMetaService.handleMeta(response);

    return response;
});
